import { DvaReducer } from '@/models/shared';
import { AnyAction } from 'redux';
import { EffectsCommandMap, Subscription } from 'dva';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import { ConnectState } from '@/models/connect';

// import { PolicyFullInfo_Type } from '@/type/contractTypes';

export interface ResourceDependencyPageState {
  resourceID: string;
  versions: {
    value: string;
    text: string;
  }[];
  version: string;
  directDependencies: {
    id: string;
    name: string;
    type: 'resource' | 'object';
    versionRange?: string;
    applyVersions?: string[];
  }[];
  baseUpcastResources: {
    resourceID: string;
    resourceName: string;
  }[];
  reload: number;
}

export interface ChangeAction extends AnyAction {
  type: 'change' | 'resourceDependencyPage/change';
  payload: Partial<ResourceDependencyPageState>;
}

export interface OnMount_Page_Action extends AnyAction {
  type: 'resourceDependencyPage/onMount_Page';
  payload: {
    resourceID: string;
  };
}

export interface OnUnmount_Page_Action extends AnyAction {
  type: 'resourceDependencyPage/onUnmount_Page';
}

export interface FetchInfoAction extends AnyAction {
  type: 'fetchInfo';
}

export interface HandleDataAction extends AnyAction {
  type: 'handleData' | 'resourceDependencyPage/handleData';
}

interface ResourceDependencyPageType {
  namespace: 'resourceDependencyPage';
  state: ResourceDependencyPageState;
  effects: {
    onMount_Page: (action: OnMount_Page_Action, effects: EffectsCommandMap) => void;
    onUnmount_Page: (action: OnUnmount_Page_Action, effects: EffectsCommandMap) => void;
    fetchInfo: (action: FetchInfoAction, effects: EffectsCommandMap) => void;
    handleData: (action: HandleDataAction, effects: EffectsCommandMap) => void;
  };
  reducers: {
    change: DvaReducer<ResourceDependencyPageState, ChangeAction>;
  };
  subscriptions: {
    setup: Subscription;
  };
}

const initStates: ResourceDependencyPageState = {
  resourceID: '',
  versions: [
    {
      value: '#all',
      text: FI18n.i18nNext.t('edit_resource_relynauth_filter_version_all'),
    },
  ],
  version: '#all',
  directDependencies: [],
  baseUpcastResources: [],
  reload: 0,
};

const Model: ResourceDependencyPageType = {
  namespace: 'resourceDependencyPage',
  state: initStates,
  effects: {
    *onMount_Page({ payload }: OnMount_Page_Action, { put }: EffectsCommandMap) {
      yield put<ChangeAction>({
        type: 'change',
        payload: {
          resourceID: payload.resourceID,
        },
      });
      yield put<FetchInfoAction>({
        type: 'fetchInfo',
      });
    },
    *onUnmount_Page({}: OnUnmount_Page_Action, { put }: EffectsCommandMap) {
      yield put<ChangeAction>({
        type: 'change',
        payload: initStates,
      });
    },
    *fetchInfo({}: FetchInfoAction, { select, call, put }: EffectsCommandMap) {
      const { resourceDependencyPage }: ConnectState = yield select(
        ({ resourceDependencyPage }: ConnectState) => ({
          resourceDependencyPage,
        }),
      );

      const params0: Parameters<typeof FServiceAPI.Resource.info>[0] = {
        resourceIdOrName: resourceDependencyPage.resourceID,
      };
      // console.log(params, 'params9iosdj;flkjlk lksdajf;lkjl');
      const {
        data: data_resourceInfo,
      }: {
        data: {
          baseUpcastResources: {
            resourceId: string;
            resourceName: string;
          }[];
          resourceVersions: {
            createDate: string;
            version: string;
            versionId: string;
          }[];
        };
      } = yield call(FServiceAPI.Resource.info, params0);

      // console.log(data_resourceInfo, 'data_resourceInfo isdjf;lksdjflkjsdkljfkljl');

      // const params1: Parameters<typeof FServiceAPI.Resource.resolveResources>[0] = {
      //   resourceId: resourceDependencyPage.resourceID,
      // };
      // const { data: data_resolveResources }: {
      //   data: {
      //     resourceId: string;
      //     resourceName: string;
      //     versions: {
      //       version: string;
      //       versionId: string;
      //       contracts: {
      //         policyId: string;
      //         contractId: string;
      //       }[];
      //     }[];
      //   }[];
      // } = yield call(FServiceAPI.Resource.resolveResources, params1);
      // console.log(data_resolveResources, 'data_resolveResources datasiodfjlsdkjflk');
      yield put<ChangeAction>({
        type: 'change',
        payload: {
          // directDependencies: data_resolveResources.map((r) => {
          //   return {
          //     id: r.resourceId,
          //     name: r.resourceName,
          //     type: 'resource',
          //     // versionRange?: string;
          //     applyVersions: r.versions.map((v) => {
          //       return v.version;
          //     }),
          //   };
          // }),
          baseUpcastResources: data_resourceInfo.baseUpcastResources.map((b) => {
            return {
              resourceID: b.resourceId,
              resourceName: b.resourceName,
            };
          }),
          versions: [
            {
              value: '#all',
              text: FI18n.i18nNext.t('edit_resource_relynauth_filter_version_all'),
            },
            ...data_resourceInfo.resourceVersions
              .map((v) => {
                return {
                  value: v.version,
                  text: v.version,
                };
              })
              .reverse(),
          ],
        },
      });

      yield put<HandleDataAction>({
        type: 'handleData',
      });
    },
    *handleData({}: HandleDataAction, { select, call, put }: EffectsCommandMap) {
      const { resourceDependencyPage }: ConnectState = yield select(
        ({ resourceDependencyPage }: ConnectState) => ({
          resourceDependencyPage,
        }),
      );
      // @ts-ignore
      const params1: Parameters<typeof FServiceAPI.Resource.getVersionListByResourceID>[0] = {
        resourceId: resourceDependencyPage.resourceID,
        // resourceId: string;
        version:
          resourceDependencyPage.version === '#all' ? undefined : resourceDependencyPage.version,
      };

      const {
        data,
      }: {
        data: {
          dependencies: {
            resourceId: string;
            resourceName: string;
            versionRange: string;
          }[];
        }[];
      } = yield call(FServiceAPI.Resource.getVersionListByResourceID, params1);
      const params2: Parameters<typeof FServiceAPI.Resource.getVersionListByResourceID>[0] = {
        resourceId: resourceDependencyPage.resourceID,
        sort: 'createDate:-1',
      };
      const {
        data: data_resourceVersions,
      }: {
        data: {
          version: string;
          dependencies: {
            resourceId: string;
            resourceName: string;
            versionRange: string;
          }[];
        }[];
      } = yield call(FServiceAPI.Resource.getVersionListByResourceID, params2);
      // console.log(data_resourceVersions, 'data_resourceVersions isdjf;23423423423432;lksdj;klfjkl;sjlkj');
      const dependencies: ResourceDependencyPageState['directDependencies'] = data
        .flatMap((d) => {
          return d.dependencies;
        })
        .map((r) => {
          return {
            id: r.resourceId,
            name: r.resourceName,
            type: 'resource' as 'resource',
            // versionRange: r.versionRange,
            applyVersions: data_resourceVersions
              .filter((rv) => {
                return rv.dependencies.some((d) => {
                  return d.resourceId === r.resourceId;
                });
              })
              .map((rv) => {
                return rv.version;
              }),
          };
        })
        .reduce<ResourceDependencyPageState['directDependencies']>((accumulator, current) => {
          const index = accumulator.findIndex((item) => {
            return item.id === current.id;
          });
          if (index === -1) {
            accumulator.push(current);
          }
          return accumulator;
        }, []);

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          // reload: resourceDependencyPage.reload + 1,
          reload: 0,
          directDependencies: dependencies,
        },
      });

      yield call(FUtil.Tool.promiseSleep, 300);

      yield put<ChangeAction>({
        type: 'change',
        payload: {
          reload: 1,
        },
      });
    },
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({}) {},
  },
};

export default Model;

// [{
//   'version': '1.0.0',
//   'dependencies': [{
//     'resourceId': '67bd7523a2df16002f20ba3b',
//     'versionRange': '^1.0.6',
//     'resourceName': 'Freelog/vue-component-2-nest',
//   }],
// }, {
//   'version': '1.0.1',
//   'dependencies': [{
//     'resourceId': '67c52451a2df16002f21c0cc',
//     'versionRange': '^1.0.2',
//     'resourceName': 'cumins/with-upcast-002',
//   }, {
//     'resourceId': '67c51514a2df16002f21be9a',
//     'versionRange': '^1.0.1',
//     'resourceName': 'cumins/with-upcast-001',
//   }, {
//     'resourceId': '67bd7523a2df16002f20ba3b',
//     'versionRange': '^1.0.6',
//     'resourceName': 'Freelog/vue-component-2-nest',
//   }],
// }];
